/**
 * Funciones helper para determinar estados de partidos y equipos
 * Reutilizables en múltiples componentes
 */

/**
 * Obtiene la clase CSS del estado del partido
 */
export const getGameStatusClass = (gameStatus) => {
  switch (gameStatus) {
    case "clarosports-next-game":
      return "game-next";
    case "clarosports-in-progress-game":
      return "game-in-progress";
    case "clarosports-finished-game":
      return "game-finished";
    case "clarosports-error-game":
      return "game-error";
    default:
      return "";
  }
};

/**
 * Obtiene la clase CSS del estado del equipo
 */
export const getTeamStatusClass = (teamClass) => {
  switch (teamClass) {
    case "clarosports-winner":
      return "team-winner";
    case "clarosports-loser":
      return "team-loser";
    case "clarosports-draw":
      return "team-draw";
    default:
      return "";
  }
};

/**
 * Determina si el partido ya ha comenzado
 */
export const hasGameStarted = (gameStatus) => {
  return (
    gameStatus === "clarosports-in-progress-game" ||
    gameStatus === "clarosports-finished-game"
  );
};

/**
 * Obtiene el texto del estado del partido
 */
export const getGameStatusText = (gameStatus) => {
  switch (gameStatus) {
    case "clarosports-next-game":
      return "Próximo";
    case "clarosports-in-progress-game":
      return "En Vivo";
    case "clarosports-finished-game":
      return "Finalizado";
    case "clarosports-error-game":
      return "Error";
    default:
      return "";
  }
};